module.exports = __webpack_public_path__ + "static/media/Ecstasy.e48cff41.svg";